<template>
  <div class="social-step-editor-sidebar-media-preview">
    <img
      :src="src"
      alt=""
      class="social-step-editor-sidebar-media-preview__img"
      @error="$emit('source-error'); error = true"
      @load="$emit('load'); error = false"
    />
    <span v-if="error" class="social-step-editor-sidebar-media-preview__error text-center">The URL for your image is not working. Please try a different image URL.</span>

    <button
      v-else
      class="btn btn-default btn-primary social-step-editor-sidebar-media-preview__button"
      @click="$emit('delete')"
    >
      Delete
    </button>
  </div>
</template>

<script>
export default {
  props: {
    src: String,
  },
  data: () => ({   
    error: false
  }),
};
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/web/_variables.scss';

.social-step-editor-sidebar-media-preview {
  display: grid;
  max-width: 100%;
  border: 1px dashed $color-regent-grey;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 10px;
  &__img {
    max-width: 100%;
    margin: 0 auto;
  }
  &__filename {
    word-break: break-word;
  }
  &__button {
    width: 100%;
    margin-top: 10px;
  }
  &__error {
    color: $red-color;
  }
}
</style>
